/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.ECommerce {

    import fld = ECommSalesReceiptRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ECommSalesReceiptEditor extends _Ext.ItemGridEditor<ECommSalesReceiptRow> {
        protected getColumnsKey() { return "ECommerce.ECommSalesReceipt"; }
        protected getDialogType() { return ECommSalesReceiptDialog; }
        protected getLocalTextPrefix() { return ECommSalesReceiptRow.localTextPrefix; }
        protected form: ECommSalesReceiptForm;

        private pendingChanges: Q.Dictionary<any> = {};

        public POSCustomerId;

        cont: JQuery;


        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ECommSalesDialog).CalculateBalanceAmt();
                }
            })
        }

        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }
        public setAdvance(advances: ReceiptRow[]) { 
            for (var i = 0; i < advances.length; i++) {
                var code = OMS.PaymentModeRow.getLookup().items.filter(x => x.Code=="Advance")[0].Code;
                var Receipt: ECommSalesReceiptRow = {
                    LedgerId: 1110,
                    ModeId: 18,
                    Code: "Advance",
                    Amount: advances[i].TotalAmount,
                    RefNo: '',
                    RefVoucherType: advances[i].RefTransId,
                    RefTransId: advances[i].RefVoucherId
                };
                Receipt[this.getIdProperty()] = "`" + this.nextId++;
                if (this.validateEntity(Receipt, Receipt.ReceiptId)) {
                    this.view.addItem(Receipt);
                }
            }
        }
        protected getButtons() {
            let buttons = super.getButtons();

            var addbutton = buttons.filter(x => x.cssClass == "add-button")[0];
            addbutton.hotkey = 'alt+r';
            addbutton.title = 'Add Receipt';


            buttons.push({
                title: "Credit Note",
                cssClass: "add-button",
                hotkey: "alt+c",
                onClick: () => {

                    // **** Validate Party before Item Selection ****
                    if (this.POSCustomerId == 0 || this.POSCustomerId == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    } else {
                        var grid = ECommerce.ECommReturnSelectGrid;
                        var filters: _Ext.SelectGridFilters = {
                            CustomerId: this.POSCustomerId
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({

                            gridType: grid, multiple: true, title: 'Select Credit Note', GridFilters: filters

                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.RefNo == t.RefNo) });
                        var self = this;
                        var details = [];

                        selectedItems2.forEach(function (value: ECommSalesReturnRow) {
                            var code = OMS.PaymentModeRow.getLookup().itemById[8].Code;
                            var Receipt: ECommSalesReceiptRow = {
                                LedgerId: value.PartyId,
                                ModeId: 8,
                                Code: code,
                                Amount: value.GrossAmount,
                                RefNo: value.VoucherNo,
                                RefVoucherType: value.VoucherTypeId,
                                RefTransId: value.TransId
                            };
                            details.push(Receipt);

                        });

                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Detail;
                            if (this.validateEntity(Detail, Detail.Id)) {
                                this.view.addItem(Detail);
                            }
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            buttons.push({
                title: " Exchange",
                cssClass: "add-button",
                hotkey: "alt+e",
                onClick: () => {

                    // **** Validate Party before Item Selection ****
                    if (this.POSCustomerId == 0 || this.POSCustomerId == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    } else {
                        var grid = ECommerce.ExchangeSelectGrid;
                        var filters: _Ext.SelectGridFilters = {
                            CustomerId: this.POSCustomerId
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({

                            gridType: grid, multiple: true, title: 'Select Exchange Note', GridFilters:filters

                        }, );
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.RefNo == t.RefNo) });
                        var self = this;
                        var details = [];

                        selectedItems2.forEach(function (value: ECommSalesReturnRow) {
                            var code = OMS.PaymentModeRow.getLookup().itemById[9].Code;
                            var Receipt: ECommSalesReceiptRow = {
                                LedgerId: value.PartyId,
                                ModeId: 9,
                                Code: code,
                                Amount: value.GrossAmount,
                                RefNo: value.VoucherNo,
                                RefVoucherType: value.VoucherTypeId,
                                RefTransId: value.TransId
                            };
                            details.push(Receipt);

                        });

                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Detail;
                            if (this.validateEntity(Detail, Detail.Id)) {
                                this.view.addItem(Detail);
                            }
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            buttons.push({
                title: "Scheme",
                cssClass: "add-button",
                hotkey: "alt+e",
                onClick: () => {

                    // **** Validate Party before Item Selection ****
                    if (this.POSCustomerId == 0 || this.POSCustomerId == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    } else {

                        var grid = Scheme.SchemeEnrollmentSelectGrid;

                        var filters: _Ext.SelectGridFilters = {
                            CustomerId: this.POSCustomerId
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: 'Select Scheme', GridFilters: filters

                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.RefNo == t.RefNo) });
                        var self = this;
                        var details = [];

                        selectedItems2.forEach(function (value: Scheme.SchemeEnrollmentRow) {
                            var code = OMS.PaymentModeRow.getLookup().itemById[3].Code;
                            var Receipt: ECommSalesReceiptRow = {
                                LedgerId: 1110,
                                ModeId: 3,
                                Code: code,
                                Amount: value.SchemeAmount + value.BonusValue,
                                RefNo: '',
                                RefVoucherType: value.SchemeId,
                                RefTransId: value.SchemeEnrollmentId
                            };
                            details.push(Receipt);

                        });

                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Detail;
                            if (this.validateEntity(Detail, Detail.Id)) {
                                this.view.addItem(Detail);
                            }
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            buttons.push({
                title: "Advance",
                cssClass: "add-button",
                hotkey: "alt+e",
                onClick: () => {

                    // **** Validate Party before Item Selection ****
                    if (this.POSCustomerId == 0 || this.POSCustomerId == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    } else {
                        var transids = [];
                        var orders = (this.parentDialog as ECommSalesDialog).form.ItemDetails.getItems();
                        for (var i = 0; i < orders.length; i++) {
                            if (orders[i].RefVoucherId == 47) {
                                transids.push(orders[i].RefTransId);
                            }
                        }
                        var currentreceipts = this.view.getItems();
                        for (var i = 0; i < currentreceipts.length; i++) {
                            if (currentreceipts[i].RefVoucherType == 47) {
                                transids.push(currentreceipts[i].RefTransId);
                            }
                        }
                        var grid = Common.AdvanceSelectGrid;

                        var filters: _Ext.SelectGridFilters = {
                            CustomerId: this.POSCustomerId,
                            TransIds:transids
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: 'Select Advance', GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.RefNo == t.RefNo) });
                        var self = this;
                        var details = [];

                        selectedItems2.forEach(function (value: ReceiptRow) {
                            var code = OMS.PaymentModeRow.getLookup().itemById[18].Code;
                            var Receipt: ECommSalesReceiptRow = {
                                LedgerId: 1110,
                                ModeId: 18,
                                Code: code,
                                Amount: value.TotalAmount,
                                RefNo: '',
                                RefVoucherType: value.RefTransId,
                                RefTransId: value.RefVoucherId
                            }; 
                            details.push(Receipt);

                        });

                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Detail;
                            if (this.validateEntity(Detail, Detail.Id)) {
                                this.view.addItem(Detail);
                            }
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });


            return buttons;
        }


        validateEntity(row: ECommSalesReceiptRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;

            row.ModeId = Q.toId(row.ModeId);
            if (row.ModeId == 3) {
                var sameProduct = Q.tryFirst(this.view.getItems(), x => x.ModeId === row.ModeId);
                if (sameProduct && this.id(sameProduct) !== id) {
                    Q.alert('This Mode of payment is already added!');
                    return false;
                }
            } else if (row.ModeId == 8 || row.ModeId == 9) {
                var sameProduct = Q.tryFirst(this.view.getItems(), x => x.RefTransId === row.RefTransId && x.RefVoucherType === row.RefVoucherType);
                if (sameProduct && this.id(sameProduct) !== id) {
                    Q.alert('This Mode of payment is already added!');
                    return false;
                }
            }
            row.Code = OMS.PaymentModeRow.getLookup().itemById[row.ModeId].Code;

            return true;
        }

    }
}